import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../../assets/css/vendor.bundle.css';
import '../../assets/css/style.css';
import '../../assets/css/theme.css';
import logo from '../../assets/images/logo.svg';

const Navbar = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isDropMenuOpen, setIsDropMenuOpen] = useState(false);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };
    const toggleDropMenu = () => {
        setIsDropMenuOpen(!isDropMenuOpen);
    };

    return (
        <div className="site-header header-s1 is-sticky">
            <div className="navbar navbar-primary">
                <div className="container relative nav-area">
                    <a className="navbar-brand" href="/">
                        <img src={logo} alt="Logo" className="logo logo-dark" />
                    </a>
                    <div className="navbar-header">
                        <button
                            type="button"
                            className="navbar-toggle"
                            onClick={toggleMenu}
                            aria-expanded={isMenuOpen}
                        >
                            <span className="sr-only">Menu</span>
                            <span className="icon-bar"></span>
                            <span className="icon-bar"></span>
                            <span className="icon-bar"></span>
                        </button>
                    </div>
                    <nav
                        className={`navbar-collapse ${isMenuOpen ? 'show' : 'collapse'}`}
                        id="mainnav"
                    >
                        <ul className="nav navbar-nav nav-style">
                            <li><Link to="/">Home</Link></li>
                            <li><Link to="/about">About Us</Link></li>
                            <li className="dropdown">
                                <Link   className="dropdown-toggle" 
                                        onClick={toggleDropMenu}
                                        aria-expanded={isDropMenuOpen}
                                >
                                    Markets <b className="caret"></b>
                                </Link>
                                <ul className={`dropdown-menu ${isDropMenuOpen ? 'sub-nav-opened' : 'sub-nav-closed'}`}>
                                    <li><Link to="/forex">Forex</Link></li>
                                    <li><Link to="/shares">Shares</Link></li>
                                    <li><Link to="/bonds">Bonds</Link></li>
                                    <li><Link to="/digital-currencies">Digital Currencies</Link></li>
                                </ul>
                            </li>
                            <li><Link to="/account-types">Account Types</Link></li>
                            <li><Link to="/contact">Contact Us</Link></li>
                            <li className="quote-btn hidden-xs hidden-sm">
                                <Link className="btn" to="/contact">get started</Link>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
        </div>
    );
};

export default Navbar;
